var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H9C9.55228 3 10 3.44772 10 4V8.125C10 8.67728 9.55228 9.125 9 9.125H3.85558C3.68789 9.125 3.52289 9.16717 3.37576 9.24763L2.59192 9.67629C2.32536 9.82207 2 9.62916 2 9.32534V4Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6C13.5523 6 14 6.46594 14 7.0407V12.5826C14 12.8594 13.7507 13.0482 13.5098 12.9892L13.4082 12.9485L12.624 12.5024C12.4769 12.4186 12.3122 12.3743 12.1445 12.3743H7C6.44772 12.3743 6 11.9084 6 11.3336V10.6832C6 10.3958 6.22386 10.1628 6.5 10.1628C6.77614 10.1628 7 10.3958 7 10.6832V11.3336H12.1445C12.4409 11.3336 12.733 11.4023 13 11.5338V7.0407H11C10.7239 7.0407 10.5 6.80773 10.5 6.52035C10.5 6.23297 10.7239 6 11 6H13Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunications);
export default __webpack_public_path__ + "static/media/Communications.3c4ecd6a051c511d04aef841a4064b23.svg";
export { ForwardRef as ReactComponent };